export enum Role {
	BACKOFFICE_SUPER_ADMIN = 'back_office_super_admin',
	BACKOFFICE_ADMIN = 'back_office_admin',
	BACKOFFICE_USER = 'back_office_user',
	COMPANY_OWNER = 'company_owner',
	COMPANY_ADMIN = 'company_admin',
	COMPANY_USER = 'company_user',
	DEVELOPER_USER = 'developer_user'
}

export const ALL_COMPANY_USERS = [Role.COMPANY_OWNER, Role.COMPANY_ADMIN, Role.COMPANY_USER];
export const ALL_BACKOFFICE_USERS = [Role.BACKOFFICE_SUPER_ADMIN, Role.BACKOFFICE_ADMIN, Role.BACKOFFICE_USER];
